import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const rebuildList = function (list: any) {
  let result = [];

  if (list) {
    result = list.concat();
    result.forEach((item: any, index: any) => {
      item._showChildren = item._showChildren !== undefined ? item._showChildren : true;
      item.isFirst = item.isFirst !== undefined ? item.isFirst : index === 0;
      item.isLast = item.isLast !== undefined ? item.isLast : index === result.length - 1;

      if (item.children) {
        item.children = rebuildList(item.children);
      }
    });
  }

  return result;
};

const URL = {
  LIST: '/dh-datamaint/caseCatalog/list',
  ADD: '/dh-datamaint/caseCatalog/add',
  DELETE: '/dh-datamaint/caseCatalog/delete',
  DETAIL: '/dh-datamaint/caseCatalog/detail',
  UPDATE: '/dh-datamaint/caseCatalog/update',
  MOVE: '/dh-datamaint/caseCatalog/move',
};

const moveTypeMap: any = {
  down: 'Down',
  reduce: 'Reduce',
  up: 'Up',
  upgrade: 'Upgrade',
};

class CatalogModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getList(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.LIST, { params: payload.data });
      return rebuildList(res.data.data || []);
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      const { children, _showChildren, isFirst, isLast, parentId, totalSort, updateTime, ...data } =
        payload.data || {};
      await ajax.post(URL.UPDATE, data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async Move(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.MOVE, {
        ...payload.data,
        moveType: moveTypeMap[payload?.data?.moveType] || payload?.data?.moveType,
      });
    }
  };
}

export const catalogModule = new CatalogModule();
